export const userLoaded = (user) => {
    return {
        type: 'USER_LOADED',
        payload: user,
    };
};

export const dictsLoaded = (dicts) => {
    return {
        type: 'DICTS_LOADED',
        payload: dicts,
    };
};
